import React from "react";
import { getAuth, signOut } from 'firebase/auth'
import {
  Link,
} from "react-router-dom";
import { MdPerson, MdPowerSettingsNew } from "react-icons/md";

const DropdownListUser = () => {
  return (
    <div className="origin-top-right absolute right-0 mt-1 mr-5 w-56 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5">
      <div className="py-1 " role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
        <Link to='/app/profile' className="block block px-4 py-2 text-md text-gray-700 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-100 dark:hover:text-white dark:hover:bg-gray-600" role="menuitem">
          <span className="flex items-center">
            <MdPerson className='mr-1'/> Mon profil
          </span>
          </Link>
        <button onClick={() => signOut(getAuth())} className="block block px-4 py-2 text-md text-gray-700 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-100 dark:hover:text-white dark:hover:bg-gray-600" role="menuitem">
          <span className="flex items-center text-red-600">
            <MdPowerSettingsNew className='mr-1 mt-1' /> Se déconnecter
          </span>
        </button>
      </div>
    </div>
  );
}

export default DropdownListUser